import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const NotFound = () => {
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();
  const isRu = currentLanguage !== 'EN';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col" data-testid="not-found-page">
      <Helmet>
        <title>{isRu ? 'Страница не найдена | ВЕЛОКС ХИНТ' : 'Page not found | VELOX HINT'}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Header />
      <div className="flex-1 max-w-3xl mx-auto px-4 py-24 text-center">
        <p className="text-7xl font-extrabold text-orange-500 mb-4">404</p>
        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          {isRu ? 'Страница не найдена' : 'Page not found'}
        </h1>
        <p className="text-gray-600 mb-8">
          {isRu
            ? 'Возможно, ссылка устарела или страница была перемещена.'
            : 'The link may be outdated or the page has been moved.'}
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button
            onClick={() => navigate('/')}
            className="bg-orange-500 hover:bg-orange-600"
            data-testid="not-found-home-btn"
          >
            <Home className="mr-2 h-4 w-4" />
            {isRu ? 'На главную' : 'Home'}
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/services')}
            data-testid="not-found-services-btn"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            {isRu ? 'К списку услуг' : 'Services'}
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
